import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { initializeTelegram } from './services/telegram';
import '@fontsource-variable/nunito/wght.css';
import '@fontsource-variable/geist-mono/wght.css';
import './styles/main.css';

await initializeTelegram();

createApp(App).use(createPinia()).use(router).mount('#app');
